import { Component, NgZone, OnInit, AfterViewInit } from '@angular/core';
import { fromEvent, Observable, Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  resizeObservable$: Observable<Event>
  resizeSubscription$: Subscription
  constructor(private ngzone: NgZone) { }

  ngOnInit(): void {    
    console.log('information: test');
    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(500)).subscribe(evt => {
      var height = window.innerHeight;
      document.getElementById('information').style.height = (height - 320).toString() + 'px';
    });
    window.dispatchEvent(new Event('resize'));
   
  }
}
